import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import router from './router'
import axios from 'axios';
import moment from 'moment';
import vueMoment from 'vue-moment';
import 'moment/locale/ru'

import '@mdi/font/css/materialdesignicons.css'
import '@mdi/font/scss/materialdesignicons.scss'

const _axios = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        Authorization: 'Bearer {token}'
    }
})

Vue.config.productionTip = false

Vue.$axios = _axios;
Vue.use(Buefy, {
    defaultNoticeQueue: false,
    defaultToastDuration: 1500,
    defaultToastPosition: 'is-top',
})

Vue.use(vueMoment, {
    moment
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
